// extracted by mini-css-extract-plugin
export default {"root":"root___wPSAq","iconContainer":"iconContainer___cwH4M","text":"text___pMMrh","icon":"icon___dswxR"};